import { config } from '@/config/env';
import { useAuthStore } from '@/features/auth/store';
import { createActionSessionClient } from './actionSession';
import { ensureShopCartContext,getShopCartContext } from './shopUiBridge';
import { ensureServiceActionContext,getServiceActionContext,isActionService } from './portalUiBridge';

let service='shop';
let epoch=0;
const scope=()=>{
  const state=useAuthStore.getState();
  const current=isActionService(service)?getServiceActionContext(service):null;
  const shop=service==='shop'?getShopCartContext():null;
  return {identity:state.isAuthenticated&&state.user?.sub?JSON.stringify([state.user.sub,state.hubspotCustomerId,state.user.permissions,state.user.roles]):'',
   service,ready:Boolean(state.isAuthenticated&&isActionService(service)&&current?.ready),
   ...(shop?.recipientEmail?{recipientEmail:shop.recipientEmail}:{}),
   ...(current?.customerId?{customerId:current.customerId}:{}),...(current?.perspective?{perspective:current.perspective}:{})};
 };
const client=createActionSessionClient({
 baseUrl:()=>config().assistant.actionApiBaseUrl??'',
 auth:()=>useAuthStore.getState().ensureValidToken(30),
 scope
});
export const resetAssistantActionSession=()=>{epoch++;client.reset();};
// Context announcements also include the first ready message during initialization.
// Invalidate issued/in-flight handles without cancelling that initialization.
export const invalidateAssistantActionContext=()=>client.reset();
export const getAssistantActionSessionToken=async(selected:string|boolean='shop')=>{
 service=typeof selected==='boolean'?'shop':selected;
 if(!isActionService(service))return null;
 const currentEpoch=epoch,requestedService=service,before=scope();
 try{if(!(service==='shop'?await ensureShopCartContext():await ensureServiceActionContext(service)))return null;}
 catch{return null;}
 if(currentEpoch!==epoch||requestedService!==service)return null;
 const after=scope();
 if(before.identity!==after.identity)return null;
 if(before.ready&&JSON.stringify([before.customerId,before.perspective,before.recipientEmail])!==JSON.stringify([after.customerId,after.perspective,after.recipientEmail]))return null;
 return client.token();
};
